import React, {useContext, useEffect, useState} from "react";
import useTranslate from "../../../../modules/local/useTranslate";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {shop_getDiscountProducts_Api} from "../../../../apis";
import _ from "lodash";
import {Link} from "react-router-dom";
import getTitle from "../../../../helpers/getTitle";
import {notifyOnError} from "../../factory/createErrorEvent";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import renderPagingLoading from "../../../MainPage/functions/renderPagingLoading";

export const ProductAdsBlockView = ({items = [], utm_source, utm_medium, utm_campaign}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)

    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        slidesToShow: 1,
        centerMode: false,
        initialSlide: 0,
        arrows: false,
        nextArrow: false,
        prevArrow: false,
    };

    if (items.length === 0) return renderPagingLoading();

    return (
        <div
            className="flex flex-col bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 w-full mx-auto">
            <div className="relative py-4 bg-gradient-to-r from-indigo-700 to-blue-600 px-3 overflow-hidden">
                <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-10 rounded-full" />
                <div className="relative z-10 flex items-center justify-between">
                    <div>
                        <h3 className="font-bold text-lg m-0 tracking-tight uppercase">
                            {t("suggested for you")}
                        </h3>
                    </div>
                </div>
            </div>

            {/* Danh sách sản phẩm nối nhau chiều dọc */}
            <div className="flex flex-col divide-y divide-gray-100">
                {items.map((book, index) => {
                    const variant = book?.product_variants?.[0] || {};
                    const hasDiscount = variant.compare_price > variant.price;
                    const discountPercent = hasDiscount
                        ? Math.round(((variant.compare_price - variant.price) / variant.compare_price) * 100)
                        : 0;

                    return (
                        <a
                            key={index}
                            href={book?.ref_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex p-4 hover:bg-blue-50/50 transition-all duration-300 no-underline items-start">
                            <div className="relative flex-shrink-0">
                                <div className="w-24 h-32 rounded-xl overflow-hidden shadow-md bg-gray-100 border border-gray-100">
                                    <img
                                        src={book?.avatar}
                                        alt={getTitle(book)}
                                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                        style={{ display: 'block' }}
                                        onError={(e) => { e.target.style.visibility = 'hidden' }}
                                    />
                                </div>
                                {hasDiscount && (
                                    <div
                                        style={{ top: -3, left: -3 }}
                                        className="absolute top-3 bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-md shadow-lg">
                                        -{discountPercent}%
                                    </div>
                                )}
                            </div>

                            {/* Khối thông tin bên phải */}
                            <div className="ml-4 flex flex-col flex-grow min-w-0">
                                <h4 className="text-gray-900 font-bold text-sm mb-1 max-lines-2 group-hover:text-indigo-600 transition-colors leading-tight">
                                    {getTitle(book)}
                                </h4>

                                <div
                                    className="text-gray-500 text-[11px] leading-snug mb-2 max-lines-2 italic"
                                    style={{textSize: 11}}
                                    dangerouslySetInnerHTML={{__html: book?.about_html}}
                                />
                                <div className="mt-auto flex items-baseline gap-2">
                                    <span className="text-indigo-600 font-extrabold text-base">
                                        {variant.price?.toLocaleString()}<span style={{marginLeft: 0.5, textSize: 10}}
                                                                               className="text-xs ml-1 font-normal uppercase">{book.price_unit?.short_name}</span>
                                    </span>
                                    {hasDiscount && (
                                        <span style={{textSize: 10}} className="text-gray-400 text-[10px] line-through">
                                            {variant.compare_price?.toLocaleString()}
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* Mũi tên chỉ hướng */}
                            <div
                                className="self-center ml-2 opacity-0 group-hover:opacity-100 transform translate-x-[-10px] group-hover:translate-x-0 transition-all">
                                <svg className="w-4 h-4 text-indigo-400" fill="none" stroke="currentColor"
                                     viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                          d="M9 5l7 7-7 7"/>
                                </svg>
                            </div>
                        </a>
                    );
                })}
            </div>

            <div className="p-4 bg-gray-50 border-t border-gray-100">
                <Link
                    to="/products"
                    className="flex items-center justify-center w-full py-3 bg-white border border-indigo-100 rounded-xl text-indigo-600 text-xs font-bold hover:bg-indigo-600 hover:text-white transition-all shadow-sm no-underline">
                    {`${t('view more products')}...`}
                </Link>
            </div>

        </div>
    )
}

export const ProductAdsHorizonView = ({items = [], utm_source, utm_medium, utm_campaign}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col gap-3">
            CaRAUSEL items
        </div>
    )
}

/// utm_source: KRISTO
/// utm_medium: ads
/// utm_campaign: ads
export const ProductAdsContainer = ({type = "block", arrays = [], keyword = "", container_type, container_id, utm_source, utm_medium, utm_campaign}) => {
    const t = useTranslate()
    const [items, setItems] = useState([])
    const [visible, setVisible] = useState(false)  // ← thêm

    const onError = notifyOnError(t)

    const {handleAsyncAction: getDiscountProducts} = useAsyncAction({
        onError,
        values: {container_type, container_id, keyword},
        apiInfo: shop_getDiscountProducts_Api,
        onSuccess: (result, data) => {
            const dataItems = _.get(data, 'response.data.data')
            setItems(dataItems)
        },
    })

    useEffect(() => {
        // Delay cả fetch lẫn render — không block initial paint
        const timer = setTimeout(() => {
            setVisible(true)
            getDiscountProducts()
        }, 1000)
        return () => clearTimeout(timer)
    }, [keyword])

    if (!visible) return null  // ← không render gì trong 3s đầu

    switch (type) {
        case "block":
            return (
                <div className="flex flex-col gap-3">
                    <ProductAdsBlockView items={items} {...{utm_source, utm_medium, utm_campaign}} />
                </div>
            )
        default:
    }

    return (
        <div className="flex flex-col gap-3">
            <ProductAdsHorizonView items={items} {...{utm_source, utm_medium, utm_campaign}} />
        </div>
    )
}

